import CustomFilterSelect from "./CustomFilterSelect";
const FilterBank = (props: any) => {
  const authrole = localStorage?.getItem("authrole")?.toString();
  return (
    <>
      {authrole === "admin" && (
        <CustomFilterSelect
          source="sBank"
          label="Search Bank"
          choices={[
            { id: "springbankny", name: "Spring Bank" },
            { id: "ntfcu", name: "NTFCU" },
            { id: "bankhappy", name: "Bank Happy" },
            { id: "solitashouse", name: "Solita's House" },
            { id: "carver", name: "Carver Federal Savings Bank" },
            { id: "ircceo", name: "IRC's Center for Economic Opportunity" },
            { id: "ptclf", name: "PEOPLE TRUST Community Loan Fund" },
            { id: "ndi", name: "National Disability Institute" },
            { id: "naac", name: "National Asian American Coalition" },
            { id: "betterfi", name: "BetterFi" },
            { id: "cleanenergycu", name: "Clean Energy Credit Union" },
            { id: "febank", name: "First Eagle Bank" },
            { id: "umez", name: "UMEZ" },
            { id: "nolb", name: "No One Left Behind" },
          ]}
          before={
            props?.before != null && props.before !== "" ? props.before : ""
          }
        />
      )}
    </>
  );
  // const before = props?.before;
  // if (before == "and") {
  //   return (
  //     <>
  //       {authrole === "admin" && (
  //         <BeforeAutocompleteInput
  //           source="sBank"
  //           label="Search Bank"
  //           variant="outlined"
  //           choices={[
  //             { id: "springbankny", name: "Spring Bank" },
  //             { id: "ntfcu", name: "NTFCU" },
  //             { id: "bankhappy", name: "Bank Happy" },
  //             { id: "solitashouse", name: "Solita's House" },
  //             { id: "carver", name: "Carver Federal Savings Bank" },
  //             { id: "ircceo", name: "IRC's Center for Economic Opportunity" },
  //             { id: "ptclf", name: "PEOPLE TRUST Community Loan Fund" },
  //             { id: "ndi", name: "National Disability Institute" },
  //             { id: "naac", name: "National Asian American Coalition" },
  //             { id: "betterfi", name: "BetterFi" },
  //             { id: "cleanenergycu", name: "Clean Energy Credit Union" },
  //             { id: "febank", name: "First Eagle Bank" },
  //             { id: "umez", name: "UMEZ" },
  //             { id: "nolb", name: "No One Left Behind" },
  //           ]}
  //         />
  //       )}
  //     </>
  //   );
  // } else {
  //   return (
  //     <>
  //       {authrole === "admin" && (
  //         <AutocompleteInput
  //           source="sBank"
  //           label="Search Bank"
  //           variant="outlined"
  //           choices={[
  //             { id: "springbankny", name: "Spring Bank" },
  //             { id: "ntfcu", name: "NTFCU" },
  //             { id: "bankhappy", name: "Bank Happy" },
  //             { id: "solitashouse", name: "Solita's House" },
  //             { id: "carver", name: "Carver Federal Savings Bank" },
  //             { id: "ircceo", name: "IRC's Center for Economic Opportunity" },
  //             { id: "ptclf", name: "PEOPLE TRUST Community Loan Fund" },
  //             { id: "ndi", name: "National Disability Institute" },
  //             { id: "naac", name: "National Asian American Coalition" },
  //             { id: "betterfi", name: "BetterFi" },
  //             { id: "cleanenergycu", name: "Clean Energy Credit Union" },
  //             { id: "febank", name: "First Eagle Bank" },
  //             { id: "umez", name: "UMEZ" },
  //             { id: "nolb", name: "No One Left Behind" },
  //           ]}
  //         />
  //       )}
  //     </>
  //   );
  // }
};

export default FilterBank;
